import type { Theme } from "~/common/mui";

export const savedConfigurationsStyles = (theme: Theme) => ({
  ".scha__lcsc__table": {
    "&__header": {
      "& > *:nth-child(1)": { width: "3%" },
      "& > *:nth-child(2)": { width: "30.6%" },
      "& > *:nth-child(3)": { width: "54.6%" },
      "& > *:nth-child(4)": { width: "11.8%" },
    },
    "&__left-side": {
      width: "33.6%",
      "&__col-container": {
        display: "flex",
        "& > *:nth-child(1)": { width: "8.9286%" },
        "& > *:nth-child(2)": { width: "91.0714%" },
      },
    },
    "&__right-side": {
      width: "66.4%",
      "&__col-container": {
        display: "flex",
        "& > *:nth-child(1)": { width: "82.2289%" },
        "& > *:nth-child(2)": { width: "17.7711%" },
      },
    },
  },
  ".scha__lcsc__table__entry": {
    paddingTop: "30px",
    paddingBottom: "30px",
  },
});
